import React from 'react'

function BudgetPlanning() {
  return (
    <div>BudgetPlanning</div>
  )
}

export default BudgetPlanning